import { connect } from 'react-redux';

import PaymentTerms from '../../components/PaymentTerms/paymentTerms'
import { fetchPaymentTerms, selectPaymentTerm, resetCurrentPaymentTerm } from '../../actions/paymentTerms_actions'

function mapStateToProps(state) {
  return {
    paymentTerms: state.paymentTerms.all,
    currentPaymentTerm: state.paymentTerms.currentPaymentTerm,
    isLoading: state.paymentTerms.isLoading,
    error: state.paymentTerms.error,
    userPermissions: state.auth.userPermissions
  };
}

export default connect(mapStateToProps, {
  fetchPaymentTerms,
  selectPaymentTerm,
  resetCurrentPaymentTerm,
})(PaymentTerms);



// WEBPACK FOOTER //
// ./master/jsx/containers/PaymentTerms/paymentTerms.jsx